module.exports = __webpack_public_path__ + "static/img/titTxtImg.deb23fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/titTxtImg.png
// module id = njBI
// module chunks = 0